import { defineMessages } from 'react-intl';

const messages = defineMessages({
  statusDefault: {
    defaultMessage: 'Default <counter></counter>',
    id: 'ZYst6f',
    description: 'Shared Carrier Status default',
  },
  statusCustomized: {
    defaultMessage: 'Customized <counter></counter>',
    id: 'epMTYT',
    description: 'Shared Carrier Status customized',
  },
  defaultTooltipMessage: {
    defaultMessage: '{partnerType} uses the Default carrier sharing settings (last changed: {modificationDate})',
    id: 'u+7mPp',
    description: 'Shared Carrier Status default tooltip',
  },
  customTooltipMessage: {
    defaultMessage: '{partnerType} uses Custom carrier sharing settings (last changed: {modificationDate})',
    id: 'KTG1Fc',
    description: 'Shared Carrier Status custom tooltip',
  },
  vendorInTooltipMessage: {
    defaultMessage: 'Vendor',
    id: '6Q5Fi+',
    description: 'Vendor part in status tooltip',
  },
  fulfillmentProviderInTooltipMessage: {
    defaultMessage: 'Fulfillment provider',
    id: 'R3wJFc',
    description: 'Fulfillment provider part in status tooltip',
  },
  notCompatible: {
    defaultMessage: 'Not compatible',
    id: '7Oh+DG',
    description: 'Shared Carrier Not Compatible',
  },
});

export default messages;
